import { jsxs, jsx } from 'react/jsx-runtime';
import cn from 'classnames';
import { isShippable } from '@sbt-web/utils';
import { VerifiedIcon, ReturnIcon } from '../Icons/index.js';
import { isPro } from '../../utils/shop.js';
import styles from './index.module.scss.js';

const ProSeals = ({ item, iconOnly }) => {
    const showSeals = isPro(item.advertiser.type) && isShippable(item);
    if (!showSeals)
        return null;
    return (jsxs("div", { className: cn(styles.seals, { [styles.iconOnly]: iconOnly }), children: [jsxs("span", { className: styles.seal, children: [jsx(VerifiedIcon, { className: styles.icon }), jsx("span", { className: cn('caption small book', styles.sealDescription), children: "Venditore verificato" })] }), jsxs("span", { className: styles.seal, children: [jsx(ReturnIcon, { className: styles.icon }), jsx("span", { className: cn('caption small book', styles.sealDescription), children: "Reso entro 14 giorni" })] })] }));
};

export { ProSeals };
//# sourceMappingURL=index.js.map
